import React, {useEffect} from 'react';

import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {AmazonV2DataType} from 'types/amazonType';

import {getPayment} from '../../store/reducers/payments/payments';

import {AmazonButtonConnected} from './amazonButton/amazonButton';
import {PaypalButtonWrapper} from './paypalButtonWrapper/paypalButtonWrapper';

import s from './paymentsButtons.scss';

export type PropsType = {
    payPalV3: {
        startUrl: string;
        client_id: string;
    } | null;
    amazon_v2: AmazonV2DataType | null;
    getButtons: () => void;
};

/**
 * Displays amazon and paypal payment systems under proceed to checkout button on react cart page
 * @params {PropsType} params
 * @returns {Node} payments buttons component
 */
export const PaymentsButtons = ({amazon_v2: amazonV2, getButtons, payPalV3}: PropsType) => {
    useEffect(() => {
        if (!payPalV3 && !amazonV2) {
            getButtons();
        }
    }, [amazonV2, getButtons, payPalV3]);

    return (
        <div aria-label="Payments Buttons" className={s.buttonBlock}>
            <PaypalButtonWrapper payPalV3={payPalV3} />
            <AmazonButtonConnected amazonV2={amazonV2} />
        </div>
    );
};

const mapDispatchToProps = {
    getButtons: getPayment,
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    amazon_v2: store.payments.amazon_v2,
    googlePay: store.payments.stripe_google_pay,
    payPalV3: store.payments.paypal_v3,
});

export const PaymentsButtonsConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentsButtons);
